// Symbols use TradingView's EXCHANGE:TICKER format. Edit freely.
export const CATEGORIES = [
  {
    id: "technology",
    label: "Technology",
    companies: [
      { name: "Apple Inc.", ticker: "AAPL", symbol: "NASDAQ:AAPL" },
      { name: "Microsoft", ticker: "MSFT", symbol: "NASDAQ:MSFT" },
      { name: "Alphabet", ticker: "GOOGL", symbol: "NASDAQ:GOOGL" },
      { name: "Meta", ticker: "META", symbol: "NASDAQ:META" },
    ],
  },
  {
    id: "semiconductors",
    label: "Semiconductors",
    companies: [
      { name: "NVIDIA", ticker: "NVDA", symbol: "NASDAQ:NVDA" },
      { name: "Broadcom", ticker: "AVGO", symbol: "NASDAQ:AVGO" },
      { name: "AMD", ticker: "AMD", symbol: "NASDAQ:AMD" },
      { name: "Micron", ticker: "MU", symbol: "NASDAQ:MU" },
    ],
  },
  {
    id: "financials",
    label: "Financials",
    companies: [
      { name: "JPMorgan", ticker: "JPM", symbol: "NYSE:JPM" },
      { name: "Visa", ticker: "V", symbol: "NYSE:V" },
      { name: "Mastercard", ticker: "MA", symbol: "NYSE:MA" },
      { name: "Bank of America", ticker: "BAC", symbol: "NYSE:BAC" },
    ],
  },
  {
    id: "healthcare",
    label: "Healthcare",
    companies: [
      { name: "Eli Lilly", ticker: "LLY", symbol: "NYSE:LLY" },
      { name: "Johnson & Johnson", ticker: "JNJ", symbol: "NYSE:JNJ" },
      { name: "UnitedHealth", ticker: "UNH", symbol: "NYSE:UNH" },
      { name: "AbbVie", ticker: "ABBV", symbol: "NYSE:ABBV" },
    ],
  },
  {
    id: "consumer",
    label: "Consumer",
    companies: [
      { name: "Amazon", ticker: "AMZN", symbol: "NASDAQ:AMZN" },
      { name: "Costco", ticker: "COST", symbol: "NASDAQ:COST" },
      { name: "Coca-Cola", ticker: "KO", symbol: "NYSE:KO" },
      { name: "McDonald's", ticker: "MCD", symbol: "NYSE:MCD" },
    ],
  },
  {
    id: "energy",
    label: "Energy",
    companies: [
      { name: "Exxon Mobil", ticker: "XOM", symbol: "NYSE:XOM" },
      { name: "Chevron", ticker: "CVX", symbol: "NYSE:CVX" },
      { name: "ConocoPhillips", ticker: "COP", symbol: "NYSE:COP" },
    ],
  },
];


// Flat list with each company tagged with its category label
export const ALL_COMPANIES = CATEGORIES.flatMap((cat) =>
  cat.companies.map((c) => ({ ...c, category: cat.label }))
);